import ChatIcon from './ChatIcon.vue'
import MailIcon from './MailIcon.vue'
import PhoneIcon from './PhoneIcon.vue'
import PinIcon from './PinIcon.vue'
import LockIcon from './LockIcon.vue'

export default {
  ChatIcon,
  MailIcon,
  PhoneIcon,
  PinIcon,
  LockIcon
}
